module.exports = __webpack_public_path__ + "img/180.3bfcf61d.jpg";